import { type InputHTMLAttributes, useState } from "react";

import TextField from "./TextField";

type PasswordFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export default function PasswordField(props: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      type={visible ? "text" : "password"}
      adornment={
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="flex items-center text-ink/60 transition-colors hover:text-ink"
          aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
          aria-pressed={visible}
          tabIndex={-1}
        >
          {visible ? <EyeIcon /> : <EyeOffIcon />}
        </button>
      }
      {...props}
    />
  );
}

function EyeIcon() {
  return (
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12s3.75-7.5 9.75-7.5 9.75 7.5 9.75 7.5-3.75 7.5-9.75 7.5S2.25 12 2.25 12Z"
      />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.98 8.22A10.48 10.48 0 0 0 2.25 12s3.75 7.5 9.75 7.5c1.66 0 3.18-.4 4.52-1.05M6.6 6.6A9.9 9.9 0 0 1 12 4.5c6 0 9.75 7.5 9.75 7.5a13.2 13.2 0 0 1-2.16 3.02M3 3l18 18M9.9 9.9a3 3 0 0 0 4.2 4.2"
      />
    </svg>
  );
}
